export var METRIC_AUTHORING_MODE;
(function (METRIC_AUTHORING_MODE) {
    METRIC_AUTHORING_MODE["custom"] = "custom";
    METRIC_AUTHORING_MODE["template"] = "template";
    METRIC_AUTHORING_MODE["code"] = "code";
})(METRIC_AUTHORING_MODE || (METRIC_AUTHORING_MODE = {}));
export const FIELD_NAMES = {
    mode: 'mode',
    name: 'name',
    internalName: 'internalName',
    description: 'description',
    level: 'level',
    categories: 'categories',
    desiredDirection: 'desiredDirection',
    computationFilePath: 'computationFilePath',
    metricTemplate: 'metricTemplate',
};
export const METRIC_DIRECTIONS = {
    Increase: 'Increase',
    Decrease: 'Decrease',
    Neutral: 'Neutral',
};
export const colorSchemeToMetricDirection = {
    Inverse: 'Decrease',
    Default: 'Increase',
    Neutral: 'Neutral',
};
export const metricDefinitionToColorScheme = {
    Decrease: 'Inverse',
    Increase: 'Default',
    Neutral: 'Neutral',
};
export const DEFAULT_METADATA = {
    name: '',
    internalName: '',
    level: '',
    mode: METRIC_AUTHORING_MODE.custom,
    description: '',
    categories: [],
    desiredDirection: '',
    computationFilePath: 'UserDefinedFiles\\MDLComputations.xml',
    metricTemplate: '',
    instanceIdToBeEdited: '',
};
export const CREATE_MODAL_FIED_VALIDATION = {
    name: { required: 'Required' },
    internalName: {
        required: 'Required',
        pattern: {
            value: /^\w+$/,
            message: 'Internal name can only contain alphabetical characters[a-zA-Z], digits[0-9] and underscore[_]',
        },
        duplicate: 'Metric internal name already exists.',
    },
    description: { required: 'Required' },
    level: { required: 'Required' },
    desiredDirection: {
        required: 'Required',
    },
    metricTemplate: { required: 'Required' },
};
export const BASE_LEVEL_NAME = 'Base';
export const METRIC_WIZARD_CATEGORY = 'MetricWizard';

//# sourceMappingURL=CreateModal.constants.js.map
